import React from 'react';
import { ArrowLeft, Briefcase, Award, Users } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { team } from '../mock';

export const TeamPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white py-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        {/* Back Button */}
        <Button
          onClick={() => navigate('/')}
          variant="outline"
          className="mb-8 border-2 border-black hover:bg-black hover:text-white"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Zurück zur Startseite
        </Button>

        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-black to-[#00CCDD] text-white px-6 py-2 rounded-full mb-6">
            <Users className="w-4 h-4" />
            <span className="font-semibold text-sm uppercase tracking-wide">Unser Team</span>
          </div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-black mb-6">
            Unser erfahrenes Team
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            3 Meister und ein hochqualifiziertes Team von über 25 Fachkräften stehen für Qualität und Expertise.
            Lernen Sie die Menschen hinter TH Bauprojekte kennen.
          </p>
        </div>

        {/* Team Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {team.map((member, index) => (
            <div
              key={member.id}
              className="bg-white rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all duration-300 border-2 border-transparent hover:border-[#00CCDD]"
            >
              {/* Icon/Avatar */}
              <div className="flex justify-center mb-6">
                <div className="w-24 h-24 rounded-full bg-gradient-to-br from-black to-[#00CCDD] flex items-center justify-center">
                  {index === 0 ? (
                    <Award className="w-12 h-12 text-white" />
                  ) : (
                    <Briefcase className="w-12 h-12 text-white" />
                  )}
                </div>
              </div>

              {/* Content */}
              <div className="text-center">
                <h3 className="text-2xl font-bold text-black mb-2">{member.name}</h3>
                <p className="text-base font-semibold text-[#00CCDD] mb-3">{member.position}</p>
                <div className="inline-block bg-gray-100 px-4 py-2 rounded-full mb-4">
                  <p className="text-sm text-gray-600 font-medium">{member.experience}</p>
                </div>
                <p className="text-gray-600 leading-relaxed">{member.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="mt-16 bg-gradient-to-br from-black to-[#00CCDD] rounded-3xl p-12 text-center text-white">
          <h3 className="text-3xl sm:text-4xl font-bold mb-4">Werden Sie Teil unseres Teams!</h3>
          <p className="text-xl mb-8 max-w-2xl mx-auto opacity-90">
            Wir sind immer auf der Suche nach talentierten Fachkräften, die unser Team verstärken möchten.
          </p>
          <Button
            onClick={() => {
              navigate('/');
              setTimeout(() => {
                document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
              }, 100);
            }}
            size="lg"
            className="bg-white text-black hover:bg-gray-100"
          >
            Jetzt Kontakt aufnehmen
          </Button>
        </div>
      </div>
    </div>
  );
};